module.exports = __webpack_public_path__ + "static/21-04-02_13-11-15_4929-5a080bb7928eec6553b5b1dea0970e7e.png";